import { AppRoutes } from 'AppRoutes';

enum EmailConfirmationRoutes {
  CONFIRM_EMAIL = '/:token',
  NOT_FOUND = '*',
}

export enum ManagementRoutes {
  PROVIDER_DETAILS = '/provider-details',
}

export enum AnalyticsRoutes {
  ITEM_REPORT = '/itemReport',
  WEEKLY_REPORT = '/restaurantWeeklyReport',
  MERCHANT_WEEKLY_REPORT = '/merchantWeeklyReport',
  PERFORMANCE_SALES = '/performance/sales',
  PERFORMANCE_OPERATIONS = '/performance/operations',
  ORDER_HISTORY_REFUNDED_ORDERS = '/dashboard/orderHistory?order_filter=refundedOrders',
}

export enum AvailabilityRoutes {
  AVAILABILITY_HISTORY = '/availability-history',
}

export enum DashboardRoutes {
  DASHBOARD = '/home',
  ORDER_HISTORY = '/orderHistory',
}

export enum DeductionRoutes {
  DEDUCTION_HISTORY_ROUTE = '/list',
}

export enum DineInRoutes {
  TABLES_ROUTE = '/tables',
  QR_CODE = '/qr-codes',
}

export enum DineOutRoutes {
  OFFERINGS_LIST_ROUTE = '/offerings',
  OFFERINGS_CREATE_ROUTE = '/offerings/create',
  OFFERINGS_EDIT_ROUTE = '/offerings/edit/:offeringId',
}

export enum RatingAndFeedbackRoutes {
  FEEDBACK = '/feedback',
}

export enum InvoicesAndSalesRoutes {
  INVOICES_AND_SALES_REPORTS = '/invoicesAndSalesReports',
}

export enum SmartPromotionRoutes {
  HOME = '/home',
  PROMOTIONS = '/promotions',
  MAXIMIZED_PROMOTIONS = '/promotions/maximized',
  CUSTOMIZED_PROMOTIONS = '/promotions/customized',
  PROMOTION_DETAILS = '/promotions/details/:promotionId',
}

enum PaidVisibilityRoutes {
  CREATE_OLD = '/create/:offerId',
  CREATE = '/create',
  DETAILS_OLD = '/details/:signupId',
  DETAILS = '/details-new/:signupId',
}

export enum MenuEditorRoutes {
  ITEM_AVAILABILITY = '/item-availability',
  ITEM_FEES_LIST_HOME = '/item-fees',
  ITEM_FEES_EDIT_ROUTE = '/item-fees/edit/:menuId/:itemId',
  ORG_SUMMARY_ROUTE = '/org-summary',
  TIMETABLES_LIST_ROUTE = '/timetables',
  TIMETABLES_CREATE_ROUTE = '/timetables/create',
  TIMETABLES_EDIT_ROUTE = '/timetables/edit/:itemId',
  MODIFIERS_LIST_ROUTE = '/modifiers',
  MODIFIERS_CREATE_ROUTE = '/modifiers/create/:menuId',
  MODIFIERS_EDIT_ROUTE = '/modifiers/edit/:menuId/:itemId',
  MODIFIERS_ADD_ITEM_ROUTE = '/modifiers/add-modifier-items/:menuId/:itemId',
  MODIFIERS_EDIT_ITEM_ROUTE = '/modifiers/edit-modifier-items/:menuId/:itemId/:childItemId',
  ITEMS_LIST_ROUTE = '/items',
  ITEMS_CREATE_ROUTE = '/items/create/:menuId',
  ITEMS_CREATE_COPY_ROUTE = '/items/create/:menuId/:copiedItemId',
  ITEMS_EDIT_ROUTE = '/items/edit/:menuId/:itemId',
  MY_MENU_HOME = '/my-menu',
  MY_MENU_CREATE_ROUTE = '/my-menu/create',
  MY_MENU_EDIT_ROUTE = '/my-menu/edit/:menuId',
  MY_MENU_DETAILS_ROUTE = '/my-menu/details/:menuId',
  MY_MENU_DETAILS_PREVIEW_ROUTE = '/my-menu/details/:menuId/preview/:language',
  MY_MENU_DETAILS_ITEM_ADD_ROUTE = '/my-menu/details/:menuId/:categoryId/category/:categoryId/item/add',
  MY_MENU_DETAILS_ITEM_COPY_ROUTE = '/my-menu/details/:menuId/:categoryId/category/:categoryId/item/add/:copiedItemId',
  MY_MENU_DETAILS_ITEM_EDIT_ROUTE = '/my-menu/details/:menuId/:categoryId/category/:categoryId/item/edit/:itemId',
  MY_MENU_DETAILS_ADD_CATEGORY_ROUTE = '/my-menu/details/:menuId/:categoryId/categories/add',
  MY_MENU_DETAILS_EDIT_CATEGORY_ROUTE = '/my-menu/details/:menuId/:categoryId/categories/edit/:categoryId',
  MY_MENU_DETAILS_TRANSLATE_CATEGORY_ROUTE = '/my-menu/details/:menuId/:categoryId?/categories/translate/:language',
}
export enum PartnerOnboardingRoutes {
  HOME = '',
  BUSINESS_DETAILS = '/business-details',
  MENU_SUBMISSION = '/item-submission',
  INFORMATION_REVIEW = '/information-review',
  COMMERCIAL_INFO = '/commercial-info',
  NEW_MERCHANT_VENUE = '/new-venue',
  NOT_FOUND = '*',
}

export enum PartnerSignupRoutes {
  HOME = '',
  RESUME_SUBMISSION = '/resume-submission/',
  LOCATION_INFORMATION = '/location-information/:token',
  ACCOUNT_INFORMATION = '/account-information/:token',
  NOT_FOUND_WITH_TOKEN = '*/:token',
  NOT_FOUND = '*',
}

export enum PublicGuidelinesRoutes {
  MAIN_PAGE = '',
  PHOTO_GUIDELINES = '/photo-guide',
  MENU_EDITOR_GUIDE = '/menu-editor-guide',
  RESTAURANT_APP_TRAINING_GUIDE = '/restaurant-app-training-guide',
  SMART_PROMOTIONS_GUIDE = '/smart-promotions-guide',
  SUNMI_V2_GUIDE = '/sunmi-v2-guide',
  SUNMI_V3_GUIDE = '/sunmi-v3-guide',
  NOT_FOUND = '*',
}

export enum SettingsRoutes {
  GENERAL = '/general',
}

export const applicationRoutes = {
  '': Object.values(AppRoutes),
  // HACK Taken from app/src/promotions/routes.ts until it migrates to modules
  marketing: [
    '/promotions',
    '/promotions/list',
    '/promotions/add',
    '/promotions/details/:promotionId',
  ],
  'email-confirmation': Object.values(EmailConfirmationRoutes),
  management: Object.values(ManagementRoutes),
  analytics: Object.values(AnalyticsRoutes),
  availability: Object.values(AvailabilityRoutes),
  dashboard: Object.values(DashboardRoutes),
  'dine-in': Object.values(DineInRoutes),
  'dine-out': Object.values(DineOutRoutes),
  'invoices-and-sales-reports': Object.values(InvoicesAndSalesRoutes),
  'menu-editor': Object.values(MenuEditorRoutes),
  'partner-onboarding': Object.values(PartnerOnboardingRoutes),
  'partner-signup': Object.values(PartnerSignupRoutes),
  'public-guidelines': Object.values(PublicGuidelinesRoutes),
  deductions: Object.values(DeductionRoutes),
  'rating-and-feedback': Object.values(RatingAndFeedbackRoutes),
  'smart-promotions': Object.values(SmartPromotionRoutes),
  'paid-visibility': Object.values(PaidVisibilityRoutes),
  settings: Object.values(SettingsRoutes),
};
